import React from 'react'
import intl from 'react-intl-universal'
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'

interface Props {
  // TODO: The story save workflow should use this modal to handle 422 errors when it is refactored off of Angular
  action: 'publish'
  isOpen: boolean
  toggle: () => void
  onConfirm: () => void
}

const WrongRevisionModal: React.FC<Props> = (props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggle}
      data-testid="wrong-revision-modal"
    >
      <ModalHeader toggle={props.toggle}>
        {intl.get(`WrongRevisionModal.${props.action}.title`)}
      </ModalHeader>
      <ModalBody>
        <Alert color="danger" className="mb-3">
          <em>{intl.get('WrongRevisionModal.error')}</em>{' '}
          {intl.get(`WrongRevisionModal.${props.action}.errorMessage`)}
        </Alert>
        {intl.getHTML(`WrongRevisionModal.${props.action}.body`)}
      </ModalBody>
      <ModalFooter>
        <Button color="link" onClick={props.toggle}>
          {intl.get(`WrongRevisionModal.${props.action}.buttons.cancel`)}
        </Button>
        <Button color="danger" onClick={props.onConfirm}>
          {intl.get(`WrongRevisionModal.${props.action}.buttons.override`)}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default WrongRevisionModal
